var map = {
	"./components/precall-test-button/precall-test-button.ts": "+2O+",
	"./components/video-chat-dropped-screen/common/services/dropped-screen-service-doctor.ts": "PLQ1",
	"./components/video-chat-dropped-screen/common/services/dropped-screen-service-patient.ts": "aJl/",
	"./components/video-chat-dropped-screen/common/services/dropped-screen-service.ts": "c3Vg",
	"./components/video-chat-dropped-screen/video-chat-dropped-screen.ts": "pmqf",
	"./directives/toggle-controls-timeout.js": "kIBN",
	"./modals/modal-disabled-camera/modal-disabled-camera.ts": "KqL7",
	"./services/pip-service/index.ts": "EHHR",
	"./services/pip-service/pip-service.ts": "qlg6",
	"./services/self-microphone-renderer.ts": "n2+x",
	"./video-chat.common.js": "aCmX"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jgsc";